module.exports = __webpack_public_path__ + "img/whalogo.0226bcaa.png";